import replacePathParams from './replacePathParams';

export default replacePathParams;
